/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState, useMemo, useEffect } from 'react';
import { Button, TextArea, Mask } from 'antd-mobile-v5';
import { CloseCircleOutline } from 'antd-mobile-icons';
import { reportPop, reportPopClick } from '@/utils/report';
import { DEFAULT_RATE_ITEM, TICKET_RESLOVED, TICKET_SLOVED_OPTIONS } from '../../config/ticket';
import Rate from './Rate';
import styles from '../index.less';

const POP_NAME = 'evaluate_pop';

const TicketEvaluateMobileModal = ({
  visible,
  ticketEvaluateRule,
  onSubmitTicketEvaluation,
  onClose,
  loading = false,
  pageName,
  ticketID,
}) => {
  const [evluateItem, setEvluateItem] = useState(DEFAULT_RATE_ITEM);
  const [choosenTags, setChoosenTags] = useState([]);
  // 是否解决问题
  const [isSloved, setIsSloved] = useState(TICKET_RESLOVED);
  // 反馈意见
  const [feedbackText, setFeedback] = useState('');

  const computeButtonDisbaled = useMemo(() => {
    let submitDisabled = false;
    if (evluateItem.value < 0) submitDisabled = true;
    if (evluateItem.commentRequired && !feedbackText) submitDisabled = true;
    if (evluateItem.tagRequired && !choosenTags.length) submitDisabled = true;
    return submitDisabled;
  }, [evluateItem, choosenTags, feedbackText]);

  const handleTagChange = useCallback(
    choosenValue => {
      const newTags = [...choosenTags];
      const valueIndex = choosenTags.findIndex(item => item === choosenValue);
      if (valueIndex >= 0) {
        newTags.splice(valueIndex, 1);
      } else {
        newTags.push(choosenValue);
      }
      setChoosenTags(newTags);
    },
    [choosenTags]
  );

  const handleSubmitRate = () => {
    const params = {
      isSloved,
      content: feedbackText,
      tagList: choosenTags.join(','),
      evaluationValue: evluateItem.value,
      evaluationWay: ticketEvaluateRule.evaluationWay,
    };
    onSubmitTicketEvaluation(params);
    reportPopClick({
      page_name: pageName,
      pop_name: POP_NAME,
      button_name: 'submit',
      ticketID,
    });
  };

  const handleReset = useCallback(() => {
    // 重置数据
    setEvluateItem(DEFAULT_RATE_ITEM);
    setIsSloved(TICKET_RESLOVED);
    setChoosenTags([]);
    setFeedback('');
  }, []);

  const handleCancelEvaluate = useCallback(() => {
    // handleReset();
    onClose();
  }, []);

  const handleRateItemChange = useCallback(item => {
    setEvluateItem(item);
    setChoosenTags([]);
  }, []);

  useEffect(() => {
    if (!visible) {
      handleReset();
    } else {
      reportPop({
        page_name: pageName,
        pop_name: POP_NAME,
      });
    }
  }, [visible]);

  return (
    <Mask visible={visible}>
      <div className={styles.evaluateMobileModalContent}>
        <div className={styles.closeIcon}>
          <CloseCircleOutline fontSize={24} color="#999" onClick={handleCancelEvaluate} />
        </div>
        <h4 className={styles.evaluateTitle}>请对本次服务进行评价</h4>
        <Rate
          className={styles.rateBox}
          onChange={handleRateItemChange}
          value={evluateItem.value}
          evaluateItemList={ticketEvaluateRule.settings ?? []}
        />
        <p className={styles.rateText}>{evluateItem.name}</p>
        <ul className={styles.rateTagList}>
          {evluateItem?.tagList.map((tag, index) => (
            <li
              key={`${tag}-${index}`}
              className={`${styles.chooseOption} ${choosenTags.includes(tag) ? styles.active : ''}`}
              onClick={() => handleTagChange(tag)}
            >
              {tag}
            </li>
          ))}
        </ul>
        <div className={styles.feedbackBox}>
          <TextArea
            size="small"
            placeholder="请输入您反馈的信息"
            rows={3}
            maxLength={200}
            showCount={(length, maxLength) => (
              <p className={styles.showCount}>
                {length}/{maxLength}
              </p>
            )}
            value={feedbackText}
            onChange={value => setFeedback(value)}
            style={{ '--font-size': '0.26rem', '--color': '#333', padding: '0.1rem' }}
          />
        </div>
        <div className={styles.sloveBox}>
          <span>您的问题：</span>
          {TICKET_SLOVED_OPTIONS.map(item => (
            <span
              key={item.value}
              className={`${styles.chooseOption} ${isSloved === item.value ? styles.active : ''}`}
              onClick={() => setIsSloved(item.value)}
            >
              {item.label}
            </span>
          ))}
        </div>
        <div className={styles.evaluateAction}>
          <Button
            color="primary"
            block
            onClick={handleSubmitRate}
            disabled={computeButtonDisbaled}
            style={{ fontSize: '0.26rem' }}
            loading={loading}
          >
            提交评价
          </Button>
        </div>
      </div>
    </Mask>
  );
};
export default TicketEvaluateMobileModal;
